import MissingValue from "../../../exceptions/missing-value";

const Guard = {
    required: (param, message) => {
        if (typeof param === "undefined" || param === null) {
            throw new MissingValue(message);
        }
    }
};

export default Guard;
